import NumberFormat, { NumberFormatProps } from "react-number-format";

const VuiNumberFormat = (props: NumberFormatProps) => {
  const {
    thousandSeparator = ".",
    decimalSeparator = ",",
    decimalScale = 0,
    displayType = "text",
    ...otherProps
  } = props;

  return (
    <NumberFormat
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      displayType={displayType}
      decimalScale={decimalScale}
      {...otherProps}
    />
  );
};

export default VuiNumberFormat;
